import './index.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const FLOATERS = [
  { e: '⚽️', x: '12%', y: '18%', delay: '0s', size: 36 },
  { e: '🏀', x: '82%', y: '22%', delay: '0.4s', size: 42 },
  { e: '🎾', x: '18%', y: '72%', delay: '0.8s', size: 28 },
  { e: '🏆', x: '78%', y: '68%', delay: '1.1s', size: 34 },
  { e: '🏐', x: '88%', y: '48%', delay: '0.2s', size: 30 },
  { e: '🎯', x: '8%', y: '48%', delay: '0.6s', size: 26 },
];

const NotFound = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <main className="not-found">
      {FLOATERS.map((f) => (
        <span
          key={`${f.e}-${f.x}`}
          className={`not-found-floater${ready ? ' is-visible' : ''}`}
          style={{
            left: f.x,
            top: f.y,
            fontSize: f.size,
            animationDelay: f.delay,
            transitionDelay: f.delay,
          }}
          aria-hidden="true"
        >
          {f.e}
        </span>
      ))}

      <div className="container not-found-content">
        <img
          src={process.env.PUBLIC_URL + '/posaicon.svg'}
          alt="Posa"
          width={72}
          height={72}
          className={`not-found-logo${ready ? ' is-visible' : ''}`}
        />

        <p className={`not-found-brand${ready ? ' is-visible' : ''}`}>Posa</p>

        <div className={`not-found-code${ready ? ' is-visible' : ''}`} aria-hidden="true">
          <span>4</span>
          <span className="not-found-ball">⚽️</span>
          <span>4</span>
        </div>

        <h1 className={`not-found-title${ready ? ' is-visible' : ''}`}>
          Out of bounds
        </h1>
        <p className={`not-found-sub${ready ? ' is-visible' : ''}`}>
          This page isn’t on the pitch. Head home and keep playing.
        </p>

        <div className={`not-found-actions${ready ? ' is-visible' : ''}`}>
          <Link to="/" className="not-found-btn not-found-btn-primary">
            Back to Home
          </Link>
          <Link to="/how-it-works" className="not-found-btn not-found-btn-secondary">
            How Posa Works
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
